export function Lockup() {
  return (
    <a href="/" aria-label="ShipStack home" style={{ display: 'flex', alignItems: 'center' }}>
      <img
        src="/logo.png"
        alt="ShipStack Inc"
        style={{ height: 48, width: 'auto', display: 'block' }}
      />
    </a>
  );
}
